import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { FormattedMessage } from 'react-intl'
import TriplePointTakeoverBackground from './components/TriplePointTakeoverBackground'
import TriplePointTakeoverHeroSubtitle from './components/TriplePointTakeoverHeroSubtitle'
import TriplePointTakeoverLogo from './components/TriplePointTakeoverLogo'
import TriplePointTakeoverSearchBanner from './components/TriplePointTakeoverSearchBanner'
import TriplePointTakeoverSearchTileBanner from './components/TriplePointTakeoverSearchTileBanner'

export const triplePointCampaignId = 'triple points june 2025'
export const triplePointsTakeoverId = 'societytriplepoints'

const societyTriplePointsTakeoverConfig: App.SiteTakeoverConfig = {
  id: triplePointsTakeoverId,
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set<App.OfferType>([
    'hotel',
    'tactical_ao_hotel',
    'direct_tour',
    'partner_tour',
    'connection_tour',
    'partner_tour',
    'cruise',
  ]),
  campaignTags: new Set([triplePointCampaignId]),
  palette: 'default',
  backgroundElement: TriplePointTakeoverBackground,
  searchPage: {
    bannerContent: <TriplePointTakeoverSearchBanner />,
    tileBanner: <TriplePointTakeoverSearchTileBanner />,
  },
  offerPage: {
    bannerContent: <Group direction="horizontal" gap={12} verticalAlign="center">
      <TriplePointTakeoverLogo size="small" />
      <b>
        <FormattedMessage
          id="787C1RDi0ZbMSRKP7Pvk"
          defaultMessage="Enjoy triple bonus points on this limited-time special offer."
          description="Offer page banner text for triple points takeover in the site takeover promotion"
        />
      </b>
    </Group>,
  },
  heroSection: {
    title: <FormattedMessage
      id="wSzD3T39qx__EOr-FeA1"
      defaultMessage="Curated escapes you’ll love"
      description="Hero section title for triple points takeover in the site takeover promotion"
    />,
    subtitle: <TriplePointTakeoverHeroSubtitle />,
    logo: <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'default',
    verticals: new Set(['home']),
    filters: [
      {
        label: <FormattedMessage
          id="2b7A3yNlLF8U3TQmFNTW"
          defaultMessage="Triple points"
          description="Filter label for triple points offers in the loyalty program section"
        />,
        value: triplePointCampaignId,
        type: 'campaignTag',
      },
      {
        label: <FormattedMessage
          id="Rc7Wd5d2gPsQJZnOXdaQ"
          defaultMessage="Dining & Drinks"
          description="Filter label for dining and drinks holiday type in the site takeover promotion"
        />,
        value: 'Dining & Drinks',
        type: 'holidayType',
      },
      {
        label: <FormattedMessage
          id="06Ex3Fq3hoeXFJik9Gtz"
          defaultMessage="Family Friendly"
          description="Filter label for family friendly holiday type in the site takeover promotion"
        />,
        value: 'Family Friendly',
        type: 'holidayType',
      },
    ],
  },
}

export default societyTriplePointsTakeoverConfig
